export default __webpack_public_path__ + "static/media/banner-image.2c697b60.svg";